import * as types from './actionTypes';
import * as authTypes from '../user/actionTypes';

// Cache of sensor/agent registrations (entered in Central, shared with Focus).
// byId is keyed on the normalised agent id so lookups are case-insensitive.
//
//   byId:    { '422462452933': { name, type, userName, vendor, ... } }
//   pending: { '<id>': true }   - in flight, do not refetch
//   failed:  { '<id>': true }   - resolved to nothing, do not refetch this session
const initialState = {
  byId: {},
  pending: {},
  failed: {}
};

const normalizeId = value =>
  (value || '')
    .toString()
    .trim()
    .toLowerCase();

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.AGENT_REGISTRY_FETCH_START: {
      const ids = Array.isArray(action.payload) ? action.payload : [];
      if (!ids.length) return state;
      const pending = { ...state.pending };
      ids.forEach(id => {
        const key = normalizeId(id);
        if (key) pending[key] = true;
      });
      return { ...state, pending };
    }
    case types.AGENT_REGISTRY_MERGE: {
      const entries = action.payload && action.payload.entries;
      if (!entries || !Object.keys(entries).length) return state;

      const byId = { ...state.byId };
      const pending = { ...state.pending };
      const failed = { ...state.failed };

      Object.keys(entries).forEach(id => {
        const key = normalizeId(id);
        if (!key) return;
        delete pending[key];
        const registration = entries[id];
        if (registration && registration.name) {
          byId[key] = registration;
          delete failed[key];
        } else {
          // Nothing name-like came back. Remember that, so a group full of
          // unregistered trackers costs one request each per session and not
          // one per refresh.
          failed[key] = true;
        }
      });

      return { ...state, byId, pending, failed };
    }
    case types.AGENT_REGISTRY_CLEAR:
      return initialState;
    // Registrations are group-scoped, so never carry them across a session.
    case authTypes.LOCAL_LOGOUT:
    case authTypes.NETWORK_LOGOUT_SUCCESS:
      return initialState;
    default:
      return state;
  }
};

const byId = state => (state && state.byId) || {};
const pending = state => (state && state.pending) || {};
const failed = state => (state && state.failed) || {};

const agentRegistrySelectors = {
  byId,
  pending,
  failed
};

export default reducer;
export { agentRegistrySelectors, initialState, normalizeId };
